import React from 'react';

function About() {
  return (
    <div className="about-page">
      <h2>About Us</h2>
      <img src="/img/Rick and Karen.png" alt="Description of the image" />
      <p>Welcome to Rick and Karen's Art Gallery! We are passionate about art and strive to showcase beautiful pieces that we have created.<br></br>
      Our gallery features a wide array of projects that we have created over many years. Each piece reflects our dedication to creativity and our love for artistic expression.<br></br>
      We believe that art is a powerful medium to convey emotions, tell stories, and inspire others. Our collection includes everything from abstract paintings to detailed sculptures, each with its own unique story and artistic value.<br></br>
      Thank you for visiting our gallery. We hope you enjoy exploring our collection and learning more about the art and artists we feature. If you have any questions or would like to learn more about our work, please feel free to reach out to us through our Contact page.</p>
      </div>
  );
}

export default About;
